var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercardOp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 32,
    viewBox: "0 0 48 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4883 4.33765H17.5088V27.6623H30.4883V4.33765Z",
    fill: "#FF5F00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.335 16.0005C18.333 13.7542 18.842 11.5368 19.8236 9.51632C20.8052 7.49581 22.2336 5.72509 24.0006 4.33822C21.8124 2.61817 19.1843 1.5485 16.4168 1.25147C13.6493 0.954433 10.8541 1.44201 8.35066 2.65848C5.84719 3.87496 3.73648 5.77125 2.25978 8.1306C0.78309 10.4899 0 13.2172 0 16.0005C0 18.7839 0.78309 21.5111 2.25978 23.8705C3.73648 26.2298 5.84719 28.1261 8.35066 29.3426C10.8541 30.5591 13.6493 31.0466 16.4168 30.7496C19.1843 30.4526 21.8124 29.3829 24.0006 27.6628C22.2336 26.276 20.8052 24.5052 19.8236 22.4847C18.842 20.4642 18.333 18.2469 18.335 16.0005V16.0005Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9999 16.0005C48 18.7839 47.217 21.5111 45.7404 23.8704C44.2638 26.2298 42.1531 28.1261 39.6497 29.3425C37.1463 30.559 34.3511 31.0466 31.5837 30.7496C28.8163 30.4526 26.1882 29.3829 24 27.6628C25.7655 26.2746 27.1928 24.5036 28.1742 22.4834C29.1557 20.4632 29.6656 18.2465 29.6656 16.0005C29.6656 13.7546 29.1557 11.5379 28.1742 9.51769C27.1928 7.49749 25.7655 5.72649 24 4.33821C26.1882 2.61817 28.8163 1.5485 31.5837 1.25146C34.3511 0.954432 37.1463 1.44203 39.6497 2.65852C42.1531 3.875 44.2638 5.7713 45.7404 8.13065C47.217 10.49 48 13.2172 47.9999 16.0005V16.0005Z",
    fill: "#F79E1B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5871 25.1927V24.7152H46.7797V24.6179H46.2893V24.7152H46.4819V25.1927H46.5871ZM47.5392 25.1927V24.6169H47.3889L47.216 25.013L47.043 24.6169H46.8926V25.1927H46.9988V24.7584L47.1609 25.1328H47.271L47.4331 24.7575V25.1927H47.5392Z",
    fill: "#F79E1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercardOp);
export default __webpack_public_path__ + "static/media/Mastercard-op.9ba8c02ca4c6d7ebb985788c31367749.svg";
export { ForwardRef as ReactComponent };